/** Unread application-chat indicators require Organization + Applications tab read. */
export const canTrackApplicationChatUnread = (userHasPermission) =>
  userHasPermission("admin.organization", "read") &&
  userHasPermission("admin.organization.applications", "read");
